import { cUtil } from "../../../functions/util";

export class cAccountStats {

  parent        = document.querySelector('.c-stats-container') as HTMLElement;
  div_from      = document.createElement('div');
  label_from    = document.createElement('label')
  input_from    = document.createElement('input');
  div_errorFrom = document.createElement('div');
  div_to        = document.createElement('div');
  label_to      = document.createElement('label');
  input_to      = document.createElement('input');
  div_errorTo   = document.createElement('div');
  button        = document.createElement('button');

  tailFrom : any;
  tailTo   : any;

  constructor() {
    
    // ---- Structure ----
    this.parent.append(this.div_from);
      this.div_from.append(this.label_from);
      this.div_from.append(this.input_from);
      this.div_from.append(this.div_errorFrom);
    this.parent.append(this.div_to);
      this.div_to.append(this.label_to);
      this.div_to.append(this.input_to);
      this.div_to.append(this.div_errorTo);
    this.parent.append(this.button);

    // ---- Texts ----
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.label_from.innerText = __('Von'          , 'custom');
    this.label_to.innerText   = __('Bis'          , 'custom');
    this.button.innerText     = __('Herunterladen', 'custom');

    // ---- Label Ids ----
    cUtil.labelIds(this.label_from, this.input_from);
    cUtil.labelIds(this.label_to  , this.input_to);

    // ---- Other ----
    this.input_from.type = 'text';
    this.input_to.type   = 'text';
    this.button.type     = 'button';
    this.button.classList.add('c-button-simple');

    // ---- Init ----
    const now               = new Date();
    const firstDayPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastDayPrevMonth  = new Date(now.getFullYear(), now.getMonth()    , 0);

    this.setDate(this.input_from, cUtil.unixToIso(firstDayPrevMonth.valueOf()));
    this.setDate(this.input_to  , cUtil.unixToIso(lastDayPrevMonth.valueOf()));
  
    this.tailFrom = tail.DateTime(this.input_from, {
      timeFormat    : false,
      today         : false,
      weekStart     : 1,
      closeButton   : false,
      dateFormat    : 'dd.mm.YYYY',
      locale        : cUtil.locale(),
    });

    this.tailTo = tail.DateTime(this.input_to, {
      timeFormat    : false,
      today         : false,
      weekStart     : 1,
      closeButton   : false,
      dateFormat    : 'dd.mm.YYYY',
      locale        : cUtil.locale(),
    });

    // ---- Events ----
    this.input_from.addEventListener('change', () => {
      const isValid     = this.validate();
    });
    this.input_to.addEventListener('change', () => {
      const isValid     = this.validate();
    });
    this.button.addEventListener('click', () => {
      const isValid     = this.validate();
      if (!isValid) return;

      const from = this.getDate(this.input_from);
      const to   = this.getDate(this.input_to);
      window.location.href = cUtil.urlP(`/c-stats-excel?from=${from}&to=${to}`);
    });

  }

  validate() {
    const isValid = 
      this.validateDate(this.input_from, this.div_errorFrom) &&
      this.validateDate(this.input_to  , this.div_errorTo);
    return isValid;
  }

  validateDate(elm: HTMLInputElement, errorElm: HTMLElement) {
    const input      = elm.value;
    const isEmpty    = input.length === 0;
    const isDate     = cUtil.validateCh(input);
    const date       = this.getDate(elm);

    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const errorMsg =
      isEmpty     ? '' :
      !isDate     ? __('Kein gültiges Datumsformat', 'custom') :
      /*else*/ '';

    errorElm.innerText = errorMsg;

    return Boolean(errorMsg.length === 0);
  }

  getDate(elm: HTMLInputElement): string {
    const isoDate  = cUtil.chToIso(elm.value)
    const dateText =  isoDate === '1970-01-01' ? '' : isoDate;
    return dateText;
  }

  setDate(elm: HTMLInputElement, date: string) {
    const textDate =
    date === ''           ? '' :
    date === '1970-01-01' ? '' :
    cUtil.isoToCh(date);
    elm.value  = textDate;
  }
}